import { FC, ReactNode } from 'react';
import { StyledCardShell } from '../styled';

interface StatisticCardShellProps {
  children: ReactNode;
}

/**
 * Shared card shell wrapper for all statistic card variants
 * Provides the common container styling (background, border, radius, height)
 */
export const StatisticCardShell: FC<StatisticCardShellProps> = ({
  children,
}) => {
  return <StyledCardShell>{children}</StyledCardShell>;
};
